import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Slider from "../components/slider"
import Seo from "../components/seo"
import ReactLinkify from "react-linkify"
import PostList from "../components/post_list_alpha"

const DinnerInFrench = ({ data }) => {

  const slider_data = data.allMdx.nodes.map((x) =>  x);

  const first_video = slider_data.shift();

  const metaData = [{
    name: "keywords",
    content: first_video.frontmatter.keywords,
  }];

  const image = getImage(first_video.fields.thumbnail);

  const description = "Watch me make recipes from Melissa Clark's Dinner in French cookbook, which includes both classic French dishes and some French-inspired creations of her own.";

  return (
    <Layout>
      <Seo title="Dinner in French" image={image} meta={metaData} description={description}/>
      <h1>Dinner in French</h1>
      <h2>My Recipes by Way of France</h2>
      <p>
        <a href="https://www.melissaclark.net/">Melissa Clark</a> is a staff writer 
        for <a href="https://www.nytimes.com/section/food">the New York Times food 
        section</a> and the author of over three dozen books. She has won several James
        Beard awards for her food writing. She is a native of Brooklynn,
        NY and spent time in France with her family as a child.
      </p>
      <p>
        You can find many recipes she has written on the New York Times site at 
        <a href="https://cooking.nytimes.com/author/melissa-clark"> this link</a>.
      </p>
      {first_video && (
        <div className="featured-video">
          <h3>{first_video.frontmatter.title}</h3>
          <Link to={first_video.fields.slug}>
            {first_video.fields.thumbnail && 
              <GatsbyImage image={getImage(first_video.fields.thumbnail)} alt={first_video.frontmatter.title + ' from ' + first_video.frontmatter.source}/> 
            }
          </Link>
          <figcaption>
            {first_video.frontmatter.description && (
              <ReactLinkify>{first_video.frontmatter.description.split('\n').shift()}</ReactLinkify>
            )}
          </figcaption>
        </div>
      )}
      {slider_data.length > 0 &&  (
      <div className="video-slider">
        <h2>More Recent Videos</h2>
        <Slider data={slider_data} />
      </div>)}
      <div className="all-videos">
        <h2>All Videos</h2>
        <PostList data={data.allMdx.nodes} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMdx(
      filter: { frontmatter: { keywords: { regex: "/dinner in french/" } } }
      sort: { order: DESC, fields: frontmatter___date }
    ) {
      nodes {
        fields {
          youtubeId
          slug
          thumbnail {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                layout: FULL_WIDTH)
            }
          }
        }
        frontmatter {
          title
          source
          date(formatString: "MMMM D, Y")
          video_url
          description
          keywords
        }
      }
    }
  }
`

export default DinnerInFrench;
